/**
 * @file QtyWithTonnes.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-20
 * @modified 2026-10-20
 * @description A line's quantity in its own unit, with the tonnes it comes to
 *              on a smaller, fainter line beneath (Cam, 20 Oct 2026 — "show qty
 *              and supplied qty … in the units chosen by the user AND in
 *              tonnes"). The wording is utils/qtyWithTonnes — this only lays
 *              it out:
 *
 *                40 × 25kg bag          2,000.00 kg          12.50 T
 *                1 pallet · 1.00 T      2.00 T
 *
 *              `line` is any row carrying the facts (qtyFactsOf reads both the
 *              snake_case and camelCase names); props given directly win over
 *              it. `label` goes before the main figure ("Supplied"). A blank
 *              quantity renders `empty` ('-' by default). `unitsOnly` shows
 *              the first line alone (where the row already shows its tonnes).
 */

import React from 'react';
import { quantityWithTonnes, qtyFactsOf } from '../utils/qtyWithTonnes';
import './QtyWithTonnes.css';

function QtyWithTonnes({ quantity, line = null, label = null, empty = '-', className = '', inline = false, unitsOnly = false, ...facts }) {
  const given = Object.fromEntries(Object.entries(facts).filter(([, v]) => v !== undefined));
  const view = quantityWithTonnes(quantity, { ...qtyFactsOf(line || {}), ...given, ...(unitsOnly ? { order: 'units' } : {}) });
  if (view.kind === 'blank') return <>{empty}</>;
  const cls = ['qty-tonnes', inline ? 'qty-tonnes--inline' : '', `qty-tonnes--${view.kind}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} title={view.title || undefined}>
      <span className="qty-tonnes-main">{label ? <span className="qty-tonnes-label">{label} </span> : null}{view.main}</span>
      {view.sub && !unitsOnly ? <span className="qty-tonnes-sub">{view.sub}</span> : null}
    </span>
  );
}

export default QtyWithTonnes;
